var _circle, _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedInIconFilled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#0A66C2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26.4,
    height: 26.4,
    transform: "translate(12 12)",
    fill: "#0A66C2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.64 35.632H15.31V21.878H19.64V35.632ZM17.472 19.972C16.9808 19.9692 16.5015 19.821 16.0945 19.5461C15.6875 19.2711 15.371 18.8818 15.1851 18.4272C14.9991 17.9726 14.952 17.4731 15.0496 16.9917C15.1473 16.5103 15.3854 16.0687 15.7338 15.7225C16.0822 15.3763 16.5254 15.1411 17.0074 15.0465C17.4893 14.9519 17.9885 15.0023 18.4419 15.1911C18.8953 15.38 19.2826 15.699 19.555 16.1077C19.8273 16.5165 19.9724 16.9968 19.972 17.488C19.9766 17.8168 19.915 18.1432 19.7908 18.4477C19.6666 18.7522 19.4824 19.0286 19.2491 19.2604C19.0158 19.4922 18.7382 19.6747 18.4329 19.7969C18.1276 19.9192 17.8008 19.9787 17.472 19.972ZM35.6 35.644H31.272V28.13C31.272 25.914 30.33 25.23 29.114 25.23C27.83 25.23 26.57 26.198 26.57 28.186V35.644H22.24V21.888H26.404V23.794H26.46C26.878 22.948 28.342 21.502 30.576 21.502C32.992 21.502 35.602 22.936 35.602 27.136L35.6 35.644Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInIconFilled);
export default __webpack_public_path__ + "static/media/linkedInIconFilled.e8773879e9879605eaa71d2b2ef22fce.svg";
export { ForwardRef as ReactComponent };